import React from "react";
import Tabs from "components/Tabs";
import startCase from "lodash/startCase";
import { BLOCK_SETTINGS_TABS_PROPS } from "components/Tabs";
import { BLOCK_TABS } from "utils/constants/fields";
import ValuesFields from "./ValuesFields";
import SettingsFields from "./SettingsFields";
import ValidationsFields from "./ValidationsFields";
import { useScrollToElement } from "utils/hooks/editor";

/**
 * Form: src/components/Form/Components/Input/index.jsx
 */
const InputFields = ({ name }) => {
  useScrollToElement(name);

  const tabProps = {
    ...BLOCK_SETTINGS_TABS_PROPS,
    tabs: [
      {
        name: startCase(BLOCK_TABS.VALUES),
        id: BLOCK_TABS.VALUES,
        node: (
          <div className="pa3">
            <ValuesFields name={name} />
          </div>
        )
      },
      {
        name: startCase(BLOCK_TABS.SETTINGS),
        id: BLOCK_TABS.SETTINGS,
        node: (
          <div className="pa3">
            <SettingsFields name={name} />
          </div>
        )
      },
      {
        name: startCase(BLOCK_TABS.VALIDATIONS),
        id: BLOCK_TABS.VALIDATIONS,
        node: (
          <div className="pa3">
            <ValidationsFields name={name} />
          </div>
        )
      }
    ]
  };

  return <Tabs key={name} {...tabProps} />;
};

export default InputFields;
